import React, {useEffect} from 'react';
import { Card, CardHeader } from 'reactstrap';
import Swal from 'sweetalert2';

const NotAuth = () => {

    useEffect(() => {
        Swal.close();
    }, []);

    return(<>
        <Card>
            <CardHeader>You Are not authorized to view this contrnt</CardHeader>
        </Card>
    </>);
};

export default NotAuth;